import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { CustomDelete, FullTable, SelectActions } from 'components';
import { claimActions } from 'store';
import { Images, PermissionList, RolePermission, useModal } from 'utils';
import { claimAppointmentsBody, claimAppointmentsHead, PENDING_CLAIM } from './constants';

const REFRESH_ACTION_TYPE = 'REFRESH_APPT_UNITS';
export const ClaimAppointments = () => {
    const { open } = useModal();
    const dispatch = useDispatch();
    const claimById = useSelector((state) => state.claim.claimById);
    const navigate = useNavigate();
    const location = useLocation();
    const info = location?.state;
    const [selectedList, setSelectedList] = useState([]);
    const filteredList = claimById?.appts?.filter((i) => !i?.removedFromClaimFlag);
    const DELETE_ACTION_TYPE =
        claimById?.status === PENDING_CLAIM && selectedList?.length === filteredList?.length ? 'DELETE_CLAIM' : 'REMOVE_APPT_FROM_CLAIM';

    // const handleClick = (item) => {
    //     const activeAppts = claimById?.appts?.filter(appt => !appt.removedFromClaimFlag);
    //     const isLastRemaining = activeAppts?.length === 1 && activeAppts[0]?.id === item?.id;
    //     const DELETE_ACTION_TYPE = (isLastRemaining && claimById?.status === PENDING_CLAIM) ? 'DELETE_CLAIM' : 'REMOVE_APPT_FROM_CLAIM';
    //     if (!item?.removedFromClaimFlag) {
    //         open(<CustomDelByNote
    //             info="Remove Appointment from Claim"
    //             text="Are you sure you want to remove this appointment from the claim? Please provide a reason for removing this appointment.."
    //             handleDel={(comment) => {
    //                 // dispatch(claimActions.removeFromClaim(item?.id, comment, claimById?.id, item?.status));
    //                 // if (isLastRemaining && claimById?.status === PENDING_CLAIM) {
    //                 //     dispatch(claimActions.deleteClaim(claimById?.id, 'noLoad'));
    //                 // }
    //                 if (claimById?.status === PENDING_CLAIM) {
    //                     if (isLastRemaining) {
    //                         dispatch(claimActions.deleteClaim(claimById?.id, 'noLoad'));
    //                     } else {
    //                         dispatch(claimActions.removeFromClaim(item?.id, comment, claimById?.id, claimById?.status));
    //                     }
    //                 } else {
    //                     dispatch(claimActions.removeFromClaim(item?.id, comment, claimById?.id, claimById?.status));
    //                 }
    //             }}
    //             innerText={'Remove'}
    //             afterSuccess={() => {
    //                 if (isLastRemaining && claimById?.status === PENDING_CLAIM) {
    //                     // dispatch(claimActions.deleteClaim(claimById?.id, 'noLoad' ));
    //                     navigate(`/claims`, { tabType: info?.tabType });
    //                 }
    //             }}
    //             inputLabel={'Reason for removing*'}
    //             actionType={DELETE_ACTION_TYPE}
    //             body={
    //                 <div>
    //                     <div className="deleting-client-info-box" style={{ alignItems: 'flex-start' }}>
    //                         <p style={{ fontWeight: 600 }}>Claim ID:</p>
    //                         <p style={{ fontWeight: 400 }}>{claimById?.displayId}</p>
    //                     </div>
    //                 </div>
    //             }
    //         />);
    //     }
    // };

    const getClaimById = () => {
        dispatch(claimActions.getClaimById(claimById?.id, 'noLoad'));
    };

    const handleCheck = (ev, item, name) => {
        ev.stopPropagation();
        ev.preventDefault();
        if (name === 'all' || name === 'selectAll') {
            let allList = filteredList?.length === selectedList?.length ? [] : filteredList?.map((i) => i?.id);
            setSelectedList(allList);
        } else {
            const list = [...selectedList];
            const uniqSet = new Set(list);

            if (!uniqSet.has(item?.id)) {
                list.push(item?.id);
            } else {
                list.indexOf(item?.id) !== -1 && list.splice(list.indexOf(item?.id), 1);
            }
            setSelectedList(list);
        }
    };

    const removeAppts = () => {
        open(
            <CustomDelete
                innerText={'Remove'}
                text="This will remove the selected appts from this claim."
                info="Remove Appointments?"
                handleDel={() => {
                    if (claimById?.status === PENDING_CLAIM) {
                        if (selectedList?.length === filteredList?.length) {
                            dispatch(claimActions.deleteClaim({ claimIds: [claimById?.id] }));
                        } else {
                            // dispatch(claimActions.removeFromClaim(claimById?.id, 'comment', claimById?.id, claimById?.status));
                            dispatch(
                                claimActions.removeFromClaim(
                                    {
                                        apptIds: selectedList,
                                        reason: ' ',
                                    },
                                    claimById?.id,
                                    claimById?.status
                                )
                            );
                        }
                    } else {
                        dispatch(
                            claimActions.removeFromClaim(
                                {
                                    apptIds: selectedList,
                                    reason: ' ',
                                },
                                claimById?.id,
                                claimById?.status
                            )
                        );
                        // dispatch(claimActions.removeFromClaim(claimById?.id, 'comment', claimById?.id, claimById?.status));
                    }
                }}
                afterSuccess={() => {
                    setSelectedList([]);
                    if (selectedList?.length === filteredList?.length && claimById?.status === PENDING_CLAIM) {
                        navigate(`/claims`, { state: { tabType: info?.tabType } });
                    }
                }}
                actionType={DELETE_ACTION_TYPE}
                body={
                    <div className="deleting-client-info-box" style={{ alignItems: 'flex-start' }}>
                        <img style={{ marginTop: '3px' }} src={Images.fileBlack} alt="icon" />
                        <p>{claimById?.displayId}</p>
                    </div>
                }
            />
        );
    };

    const handleAction = (item, name) => {
        if (name === 'refresh') {
            open(
                <CustomDelete
                    info="Refresh Appointment Units"
                    text="Are you sure you want to refresh the units for this appointment? This will recalculate units based on the current appointment time."
                    innerText={'Refresh'}
                    color={'blue'}
                    handleDel={() => {
                        dispatch(claimActions.refreshApptUnits(item?.id, claimById?.id));
                    }}
                    actionType={REFRESH_ACTION_TYPE}
                />
            );
        }
    };

    return (
        <div>
            {!!selectedList?.length && (
                <SelectActions
                    noSubmit={true}
                    selectInnetText={selectedList?.length === filteredList?.length ? 'Clear Selection' : 'Select All'}
                    actionType={DELETE_ACTION_TYPE}
                    selectedList={selectedList?.length}
                    selectAll={handleCheck}
                    removeSelected={() => setSelectedList([])}
                    renderOtherBtns={
                        RolePermission([PermissionList.REMOVE_CLAIM_APPT?.code]) && (
                            <div className="flex-align-center" style={{ height: 30, gap: 8 }}>
                                <button onClick={removeAppts} className="selector-action-btn" style={{ width: '100%' }}>
                                    <img style={{ color: '#FF3D2F' }} src={Images.remove} alt="remove" />
                                    <p style={{ color: '#FF3D2F', fontWeight: 600 }}>Remove from Claim</p>
                                </button>
                            </div>
                        )
                    }
                />
            )}

            <FullTable
                head={claimAppointmentsHead(handleCheck, filteredList, selectedList)}
                body={claimAppointmentsBody(claimById, getClaimById, handleCheck, filteredList, selectedList)}
                list={claimById?.appts}
                noText={'appointments'}
                activeRowId={''}
                handleClickButton={handleAction}
                margin={'0'}
                selectedList={selectedList}
            />
        </div>
    );
};
